import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

export const listServers = (user) => async (dispatch) => {
    try {
        localStorage.setItem('selectedServerName', ''); 
        localStorage.setItem('noServersData', 'false');
        
        const { data } = await api.listServers({user: user});
       
        if (data?.servers?.length === 0) {
           localStorage.setItem('noServersData', 'true');
        }

        dispatch({
            type: Actions.LIST_SERVERS,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}








